"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalWrapper = exports.ModalRenderer = exports.ModalContent = exports.Footer = exports.ContentWrapper = exports.ContainerWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreContainer = require("@vfuk/core-container");

var _coreMixins = require("@vfuk/core-mixins");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ModalRenderer = _styledComponents["default"].div.withConfig({
  displayName: "ModalRendererstyle__ModalRenderer",
  componentId: "sc-160y6ux-0"
})(function (props) {
  return (0, _styledComponents.css)(["display:flex;align-items:center;justify-content:center;", " position:fixed;top:0;left:0;right:0;bottom:0;z-index:", ";"], (0, _coreMixins.spacing)('padding', 3), props.zIndex);
});

exports.ModalRenderer = ModalRenderer;

var ModalWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ModalRendererstyle__ModalWrapper",
  componentId: "sc-160y6ux-1"
})(function (props) {
  return (0, _styledComponents.css)(["position:fixed;top:0;left:0;right:0;bottom:0;z-index:", ";width:100%;pointer-events:none;display:flex;align-items:center;justify-content:center;flex-direction:column;", ""], props.zIndex, _coreMixins.respondTo.md((0, _styledComponents.css)(["top:", "px;left:", "px;right:", "px;bottom:", "px;width:auto;"], props.theme.spacing.responsive[5].md, props.theme.spacing.responsive[5].md, props.theme.spacing.responsive[5].md, props.theme.spacing.responsive[5].md)));
});

exports.ModalWrapper = ModalWrapper;

var ContainerWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ModalRendererstyle__ContainerWrapper",
  componentId: "sc-160y6ux-2"
})(function (props) {
  return (0, _styledComponents.css)(["pointer-events:auto;width:", ";max-height:100%;", " ", " ", " ", " & > ", "{width:100%;max-height:100%;", " ", " & > div{max-height:100%;overflow:auto;}}"], props.size.sm, props.fullScreenOnSM && (0, _styledComponents.css)(["height:100%;"]), _coreMixins.respondTo.md((0, _styledComponents.css)(["max-width:", ";height:auto;"], props.size.md)), _coreMixins.respondTo.lg((0, _styledComponents.css)(["max-width:", ";height:auto;"], props.size.lg)), _coreMixins.respondTo.xl((0, _styledComponents.css)(["max-width:", ";height:auto;"], props.size.xl)), _coreContainer.ContainerStyles.Container, props.fullScreenOnSM && (0, _styledComponents.css)(["border-radius:0;"]), _coreMixins.respondTo.md((0, _styledComponents.css)(["border-radius:", ";"], props.theme.border.radius[2])));
});

exports.ContainerWrapper = ContainerWrapper;

var ModalContent = _styledComponents["default"].div.withConfig({
  displayName: "ModalRendererstyle__ModalContent",
  componentId: "sc-160y6ux-3"
})(function () {
  return (0, _styledComponents.css)(["max-height:100%;overflow:auto;", ""], (0, _coreMixins.spacing)('padding', 7));
});

exports.ModalContent = ModalContent;

var Footer = _styledComponents["default"].footer.withConfig({
  displayName: "ModalRendererstyle__Footer",
  componentId: "sc-160y6ux-4"
})(function (props) {
  return (0, _styledComponents.css)(["position:sticky;bottom:0;border-top:", " ", " ", ";"], props.theme.border.width[1], props.theme.border.style[1], props.modalTheme.appearance[props.appearance].footer.borderColor);
});

exports.Footer = Footer;

var ContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ModalRendererstyle__ContentWrapper",
  componentId: "sc-160y6ux-5"
})(function () {
  return (0, _styledComponents.css)(["position:relative;"]);
});

exports.ContentWrapper = ContentWrapper;
//# sourceMappingURL=ModalRenderer.style.js.map